import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HeaderComponent } from './header/header.component';
import { CapturaComponent } from './captura/captura.component';
import { HomeComponent } from './home/home.component';
import { ListagemComponent } from './listagem/listagem.component';
import { DetalheComponent } from './detalhe/detalhe.component';
import { HistoricoComponent } from './historico/historico.component';
import { LoginComponent } from './login/login.component';
import { GrupoUsuariosComponent } from './grupo-usuarios/grupo-usuarios.component';

import { AuthGuard } from './_helpers/auth.guard';
import { ImageAloneComponent } from './image-alone/image-alone.component';
import { GroupListComponent } from './group-list/group-list.component';
import { DirectoryListComponent } from './directory-list/directory-list.component';
import { DirectoryDetailComponent } from './directory-detail/directory-detail.component';
import { PdvListComponent } from './pdv-list/pdv-list.component';
import { PdvDetailComponent } from './pdv-detail/pdv-detail.component';
import { TooltipPageComponent } from './tooltip-page/tooltip-page.component';
import { AuthCalbackComponent } from './auth-calback/auth-calback.component';
import { GroupDetailV2Component } from './group-detail-v2/group-detail-v2.component';
import { UserPerformanceComponent } from './user-performance/user-performance.component';
import { UserPerformanceReviewsComponent } from './user-performance-reviews/user-performance-reviews.component';
import { ListagemPendingIssuesComponent } from './listagem-pending-issues/listagem-pending-issues.component';
import { DetalhePendingIssuesComponent } from './detalhe-pending-issues/detalhe-pending-issues.component';
import { RelatorioIntervencoesComponent } from './home/relatorio-intervencoes/relatorio-intervencoes.component';
import { ErrosImportacaoComponent } from './erros-importacao/erros-importacao.component';
import { ZipsContagemComponent } from './zips-contagem/zips-contagem.component';
import { MonitoramentoProcessosComponent } from './monitoramento-processos/monitoramento-processos.component';

const routes: Routes = [
  { path: '', component: HomeComponent },
  { path: 'receitas', component: ListagemComponent, canActivate: [AuthGuard] },
  { path: 'receita/:uid', component: DetalheComponent, canActivate: [AuthGuard] },

  { path: 'receitas-pending-issues', component: ListagemPendingIssuesComponent, canActivate: [AuthGuard] },
  { path: 'receita-pending-issues/:uid/:regiao', component: DetalhePendingIssuesComponent, canActivate: [AuthGuard] },
  { path: 'captura', component: CapturaComponent, canActivate: [AuthGuard] },
  { path: 'historico/:uid', component: HistoricoComponent, canActivate: [AuthGuard] },
  { path: 'login', component: LoginComponent },
  { path: 'grupo-usuarios/:idGrupoRegion', component: GrupoUsuariosComponent, canActivate: [AuthGuard], data: { roles: ['admin','admin_grupo','admin_global_grupo'] } },
  { path: 'image', component: ImageAloneComponent },
  { path: 'grupo-lista', component: GroupListComponent, canActivate: [AuthGuard], data: { roles: ['admin','admin_grupo','admin_global_grupo'] } },
  { path: 'grupo-detalhe/:uid/:idGrupoRegion/:action', component: GroupDetailV2Component, canActivate: [AuthGuard], data: { roles: ['admin','admin_grupo','admin_global_grupo'] } },
  { path: 'diretorio-lista', component: DirectoryListComponent, canActivate: [AuthGuard] , data: { roles: ['admin'] }},
  { path: 'diretorio-detalhe/:uid', component: DirectoryDetailComponent, canActivate: [AuthGuard] , data: { roles: ['admin'] }},
  { path: 'pdv-lista', component: PdvListComponent, canActivate: [AuthGuard] , data: { roles: ['admin'] }},
  { path: 'pdv-detalhe/:uid', component: PdvDetailComponent, canActivate: [AuthGuard] , data: { roles: ['admin'] }},
  { path: 'performance', component: UserPerformanceComponent, canActivate: [AuthGuard], data: { roles: ['admin','admin_global_grupo', 'admin_grupo'] } },
  { path: 'performance-reviews', component: UserPerformanceReviewsComponent, canActivate: [AuthGuard] },
  { path: 'tooltip', component: TooltipPageComponent },
  { path: 'relatorio-intervencoes', component: RelatorioIntervencoesComponent, canActivate: [AuthGuard] },
  { path: 'erros-importacao', component: ErrosImportacaoComponent, canActivate: [AuthGuard], data: { roles: ['admin'] } },
  { path: 'zips-contagem', component: ZipsContagemComponent, canActivate: [AuthGuard], data: { roles: ['admin'] } },
  { path: 'monitoramento-processos', component: MonitoramentoProcessosComponent, canActivate: [AuthGuard], data: { roles: ['admin'] } },
  { path: 'auth-callback', component: AuthCalbackComponent },
  { path: 'auth-callback/login', redirectTo: 'login' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
